import LimitedEditionIcon from "src/assets/all-icons/limited-edition-icon.jsx";

import GalleryIcon from '@/assets/all-icons/gallery-icon';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import Text from '@/shared-components/text/components/Text';
import Utils from '@/utils';
import { getArtworkArtistDisplayName } from '@/utils/artworkArtists';

import './styles/CollectionCard.css';

export default function CollectionCard({ data, setArtworkToChangeVisibility }) {
  const productMetadata = data?.product_metadata ?? {};
  const artworkAbout = data?.artwork_about ?? {};
  const artworkMedia = data?.artwork_media ?? {};
  const artworkSize = artworkAbout?.artwork_size ?? {};
  const isLimitedEdition = productMetadata?.is_limited_edition === true;
  const isPrivate = productMetadata?.is_private === true;
  const artistName = getArtworkArtistDisplayName(data);

  return (
    <>
      <div className="collection-card__outter-container element-non-selectable">
        <div className="collection-card__container">
          <div className="collection-card__header">
            {
              !isLimitedEdition ?
                <div className="collection-card__seller">
                  <GalleryIcon className="collection-card__seller-original"/>

                  <Text className="collection-card__seller-text dots-on-overflow font-size-large">
                    {artworkAbout?.artwork_gallery?.user_name ?? "-"}
                  </Text>
                </div>
                :
                <div className="collection-card__seller">
                  <LimitedEditionIcon className="collection-card__seller-limited"/>

                  <Text className="collection-card__seller-text dots-on-overflow font-size-large">
                                        Suarte
                  </Text>
                </div>
            }

            <Text className="collection-card__bought-at font-size-small">
              {Utils.getDateInStringFromTimestamp(productMetadata?.artwork_bought_at)}
            </Text>
          </div>

          <div className="collection-card__content">
            <ArtworkImage
              image={artworkMedia?.artwork_main_picture?.image_id}
              imageClassName="collection-card__image"
              imageTemplateClassName="collection-card__image"
            />

            <div className="collection-card__info">
              <Text
                className="collection-card__big-text title dots-on-overflow font-size-large">
                {artworkAbout?.artwork_title ?? "-"}
              </Text>

              <div>
                <Text className="collection-card__small-text dots-on-overflow font-size-small">
                  by {artistName}
                </Text>

                <Text className="collection-card__small-text dots-on-overflow font-size-small">
                  {
                    !isLimitedEdition ?
                      "Original artwork"
                      :
                      "Limited edition"   
                  }
                </Text>

                <Text className="collection-card__small-text dots-on-overflow font-size-small">
                  {artworkSize?.length ?? "-"}{" "}
                  {artworkSize?.unit ?? ""} x{" "}
                  {artworkSize?.height ?? "-"}{" "}
                  {artworkSize?.unit ?? ""}{" "} 
                </Text>
              </div>

              <div className="collection-card__price-and-visibility">
                <Text className="collection-card__big-text dots-on-overflow font-size-large">
                  {Utils.getArtworkPrice(artworkAbout?.artwork_price, artworkAbout?.artwork_currency)}
                </Text>

                <Text className="collection-card__visibility-text">
                  {isPrivate ? 
                    "This artwork is private." : 
                    "This artwork is public."}
                  <br />
                  <a href="#" onClick={(e) => {
                    e.preventDefault();
                    setArtworkToChangeVisibility(data);
                  }}>
                    {isPrivate ? "Showcase artwork" : "Hide artwork"}
                  </a>
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
